module.exports = __webpack_public_path__ + "img/number_of_birds.32a977c1.svg";